<template>

	<div class="infoBox">
	
            <h3 v-if="panoramaTour" class="tourText">{{panoramaTour.getName()}}</h3>
  
	</div>
	<!--
	<md-card>
    
    <md-card-area>
		<md-card-header>
          <h3 style="text-align=right; display: inline-block;">{{panoramaTour.getName()}}</h3>
        </md-card-header>
        <md-card-expand>
            <md-card-actions md-alignment="space-between">
                       
                            <md-button class="md-icon-button">
                               <ChevronDown/>
                            </md-button>
                 
                    </md-card-actions>
                    <md-card-expand-content>
                        <md-card-content>
                           Ganz tolle Tour! {{panoramaTour.description}}
                        </md-card-content>
                    </md-card-expand-content>                    
                </md-card-expand>
            </md-card-area>
      
    </md-card>
-->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex';
// v-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
//import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
//import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'

//import {errorHandler} from "../utils/error-handler";

Vue.component('v-select', vSelect);

export default {
	//components: { ChevronDown, ChevronUp},
	name: 'tour-info',
	data: () => ({
		scheduledChange: false,
		selectedSituationId: null
	}),
	computed: {
		...mapGetters(['situations','currentSituation', 'panoramaTour'])
	},
	mounted: function () {
		if (this.currentSituation) {
			this.selectedSituationId = this.currentSituation.id;
		}
	},
	watch: {
		situations: function () {
			if (!this.selectedSituationId && this.currentSituation) {
				this.selectedSituationId = this.currentSituation.id;
			}
		},
		currentSituation: function () {
			if (this.scheduledChange) {
				this.scheduledChange = false;
				return;
			}
			this.selectedSituationId = this.currentSituation.id;
		}
	},
	methods: {
		changeSituation () {
			const self = this;
			const situation = this.situations.find((s) => {
				const matchSituation = s.id === self.selectedSituationId;
				const matchCurrentSituation = self.currentSituation && s.id === self.currentSituation.id;
				return matchSituation && !matchCurrentSituation;
			});
			if (situation) {
				this.scheduledChange = true;
				this.$store.commit('handleGotoSituationTransition', { situationID: situation.id } );
			}
		}
	},
}

</script>



<style lang="scss" scoped>
.tourText{
	line-height: 50%;
	white-space: nowrap;
}
.md-card {
    width: 150px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
	background:rgba(48, 47, 47, 0.767); 
	border-radius: 5px;
	color: white;
  }
.md-titel{
	color:white;
}
.md-card-header{
	color:white;
}
  .infoBox{
	
	width:150px; 
	height:60px;  
	border-radius: 5px;
	padding: 10px;
	color: white;
}
</style>

